import { ExecutiveAssistantAgent } from './agent'
import { Onboarding } from './onboarding'
import { Settings } from './settings'

export const ExecutiveAssistantClient = {
  Agent: ExecutiveAssistantAgent,
  Settings,
  Onboarding,
}
